import { UserPopupView } from 'common/module/user/popup/view';
import { UserPopupViewFactory } from 'common/module/user/popup/view.factory';

const view = UserPopupViewFactory();

view.initialize();

export function UserPopupService(): UserPopupView {
  return view;
}
